import React from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useModelQuery from '../hooks/useModelQuery';
import ModelForm from '../components/ModelForm';
import getFormTitle from '#/common/utils/getFormTitle';

export interface ModelParams {
  readonly id?: string;
}

const ModelPage: React.FC = () => {
  const { id } = useParams() as ModelParams;
  const modelQuery = useModelQuery(id);
  const model = modelQuery.data?.getModel?.data;

  const modelName = model?.name;
  const title = getFormTitle(id, modelName, 'Model');

  return (
    <SubPage title={title} isLoading={modelQuery.loading} showGoBackButton type="form">
      {<ModelForm title={title} model={model || {}} />}
    </SubPage>
  );
};

export default React.memo(ModelPage);
